export default "/images/3437ec8fbe0ec3705035ca01596ce76e.png";